import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 50rem;
  flex-direction: column;
  border-radius: 6px;
  > div:nth-child(1){
    width: 8rem;
    > input {
      text-align: center;
      &:disabled {
        opacity: 0.5;
        cursor:no-drop;
        color: #7e8c94; 
        background-color:#eff2f7;
        user-select: none;
      }
    }
  }
  > div {
    display: flex;
    height: 3rem;
    justify-content: center;
    align-items: center;
    padding: 0 .5rem 0 .5rem;
    gap: .5rem;
    > input {
      outline: none;
      width: 100%;
      height: 2.5rem;
      padding: 5px 12px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 6px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgb(236, 236, 236);
      pointer-events: auto;
      color: rgb(73, 80, 87);
    }
    > span {
      display: flex;
      width: 2.5rem;
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      background-color: rgb(29, 134, 255);
      color: #ffffff;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
    }
  }

`;